"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Constraint_1 = require("./Constraint");
/**
 * SimpleConstraint representation.
 *
 * @author RV
 */


var SimpleConstraint =
/*#__PURE__*/
function (_Constraint_1$Constra) {
  _inherits(SimpleConstraint, _Constraint_1$Constra);

  /**
   * @param value the value of simple constraint
   */
  function SimpleConstraint(value) {
    var _this;

    _classCallCheck(this, SimpleConstraint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleConstraint).call(this));
    _this.value = value;
    return _this;
  }

  return SimpleConstraint;
}(Constraint_1.Constraint);

exports.SimpleConstraint = SimpleConstraint;